/**
 * RideStoryMock — iter87.516
 *
 * A themed re-creation of the real "The Ride — As Told By Our
 * Storyteller" card from `LeagueRecap.jsx` (header text, cyber Pro+
 * pill, italic AI-written paragraph, footer note — copied verbatim
 * from that component's actual JSX). Not a live screenshot — getting
 * one would need a fully completed tournament with real match
 * history and an AI-generated story first. Themed with the same
 * rivalry/user/team names already used across the real screenshots
 * on this page (Sunday Squad, alex_admin, Office Golf, La Liga
 * Weekly) so it reads consistently instead of generic placeholder
 * copy. Deliberately plain/unobtrusive — it's a background "peek",
 * not a slide of its own.
 */
import React from "react";

export default function RideStoryMock() {
    return (
        <div className="w-full h-full bg-[#0a0a0a] p-3 flex flex-col gap-2 overflow-hidden">
            <div className="flex items-center gap-1.5">
                <span className="text-xs leading-none">📖</span>
                <p className="font-display font-extrabold text-[9px] uppercase tracking-tight text-white leading-tight">
                    The Ride — As Told By Our Storyteller
                </p>
            </div>
            <span className="pill bg-cyber/15 border-cyber text-cyber text-[7px] font-bold px-1.5 py-0.5 w-fit">
                Pro+
            </span>
            <p className="text-[8px] text-zinc-300 leading-snug italic">
                "Week 8 was alex_admin's reckoning on Sunday Squad — the La
                Liga Weekly boost finally broke Office Golf's cold streak,
                and the leaderboard flipped twice before Sunday night."
            </p>
            <p className="text-[6.5px] text-zinc-600 mt-auto">
                Written by AI from Sunday Squad's actual ride chart.
            </p>
        </div>
    );
}
